var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/addon'], function($, core, BaseCollection, AddOnModel) {
  var AddOnCollection;
  return AddOnCollection = (function(_super) {
    var isLocal;

    __extends(AddOnCollection, _super);

    function AddOnCollection() {
      AddOnCollection.__super__.constructor.apply(this, arguments);
    }

    AddOnCollection.prototype.useV2BookkeepingApi = (isLocal = window.location && window.location.hostname && /localhost|service\.bench|benchception\.co/.test(window.location.hostname), !isLocal);

    AddOnCollection.prototype.initialize = function(models, options) {
      if (options == null) {
        options = {};
      }
      return this.clientId = options.clientId ? options.clientId : core.getCurrentClientId();
    };

    AddOnCollection.prototype.path = function() {
      if (this.useV2BookkeepingApi) {
        return '/client/' + this.clientId + '/addons';
      } else {
        return core.getConfig().apiPrefix + 'addon.json/client/' + this.clientId;
      }
    };

    AddOnCollection.prototype.model = AddOnModel;

    return AddOnCollection;

  })(BaseCollection);
});
